var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECE9F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E2DEEC",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9298 26.4386C29.8711 26.4133 29.8331 26.3559 29.8331 26.2919V25.2246C29.8331 25.1506 29.8718 25.0859 29.9058 25.0746C30.7678 24.7906 31.2878 23.9299 31.1418 23.0286C30.9998 22.1566 30.1918 21.4993 29.2618 21.4993H26.7378C25.8078 21.4993 24.9998 22.1566 24.8578 23.0286C24.7111 23.9306 25.2311 24.7913 26.0938 25.0746C26.1278 25.0859 26.1664 25.1499 26.1664 25.2246V26.2919C26.1664 26.3559 26.1284 26.4133 26.0691 26.4393C24.8924 26.9526 24.1458 28.1086 24.1664 29.3859C24.1771 29.9999 24.6984 30.4999 25.3298 30.4999H27.4998V33.9999C27.4998 34.2759 27.7238 34.4999 27.9998 34.4999C28.2758 34.4999 28.4998 34.2759 28.4998 33.9999V30.4999H30.2344C31.7004 30.4999 31.8284 29.6473 31.8331 29.3859C31.8538 28.1086 31.1071 26.9526 29.9298 26.4386Z",
    fill: "#402080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinedIcon);
export default __webpack_public_path__ + "static/media/pined-icon.e25e339a56bc520e9d460939e70c6344.svg";
export { ForwardRef as ReactComponent };